import React from "react";

import {
  formatAggregateRl,
  formatAlLevel,
  getAlLevelBadgeClass,
  getRlBandPillStyle,
} from "./relationshipUtils";

export function AccountAlRlPills({ account, layout = "column" }) {
  const alLabel = formatAlLevel(account?.alLevel);
  const rlLabel = formatAggregateRl(account?.rlAggregate);
  return (
    <div
      className={`t3-l0-level-pills${layout === "row" ? " t3-l0-level-pills--row" : ""}`}
    >
      <span
        className={`al-b ${getAlLevelBadgeClass(account?.alLevel)} t3-l0-score-pill`}
      >
        {alLabel}
      </span>
      <span
        className="t3-l0-rl-pill"
        style={getRlBandPillStyle(account?.rlAggregate)}
      >
        {rlLabel}
      </span>
    </div>
  );
}
